// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"_1ln9M___Navigation-module__sectionTitle","navigation":"_3rTe7___Navigation-module__navigation"};